import React, { Component } from "react";
import {
  Row,
  Col,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
  Button,
} from "reactstrap";
import axios from "axios";
import moment from "moment";
import { END_POINT, END_POINT_SOCKET } from "../../../constants/defaultValues";
import {
  SetItemsSelected,
  NotificatioErrController,
  NotificatioSucController,
  AddCommaNumber,
} from "../../../helpers/Utils";import createSocket from "../../../helpers/createSocket";
import {
  PageHeading,
  ContentForm,
  ContentFormLog,
  ContentFormItemLog,
  ContentLog,
  Log,
  ContentDisplay,
  ListItemFormMobile,
  CompanyProviderApplicationMenu,
  ProviderKPISummary,
  ProviderFilterBar,
  ProviderDataTable,
  ProviderDetailPanel,
} from "../../../containers/pages/company-provider";
import { Add, Update, Pagination } from "../../../containers/pages/general";
import LogsHelper from "../../../helpers/Logs";
import IntlMessages from "../../../helpers/IntlMessages";
import classnames from "classnames";
import { isC, isR, isU, isD } from "../../../helpers/Roles";
import { NavLink } from "react-router-dom";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import "../../../assets/css/company-provider-redesign.css";

import FooterCompanyProvider from "../../../containers/pages/company-provider/FooterCompanyProvider";
import FooterPage from "../../../containers/pages/FooterPage";
import { Separator } from "../../../components/common/CustomBootstrap";
import AddCompanyProvider from "../../../containers/pages/company-provider/AddCompanyProvider";
import AddCompanyProviderLog from "../../../containers/pages/company-provider/AddCompanyProviderLog";
import AddCompanyProviderItemLog from "../../../containers/pages/company-provider/AddCompanyProviderItemLog";
import UpdateCompanyProvider from "../../../containers/pages/company-provider/UpdateCompanyProvider";
import ListItemLeftForm from "../../../containers/pages/company-provider/ListItemLeftForm";
import ContentMultiForm from "../../../containers/pages/company-provider/ContentMultiForm";
import { connect } from "react-redux";
import { setSearchContext } from "../../../redux/actions";

const DEFAULT_FORM = {
  id: "",
  name: "",
  phone: "",
  email: "",
  address: "",
  tax_code: "",
  notes: "",
  price: "",
  quantity: "",
  total_price_income: "",
  total_price_outcome: "",
  total_price_pending: "",
  price_income: "",
  price_outcome: "",
  price_pending: "",
  log: [],
  items_selected: null,
  //item log
  item_id: "",
  item_name: "",
  new_item_unit: "",

  dynamic_form: [],
};

const formatDatasExport = (data) => {
  let custs = [];

  for (let i = 0, j = data?.length; i < j; i++) {
    custs.push({
      Stt: i + 1,
      "Tên nhà cung cấp": data[i].name,
      "Số điện thoại": data[i].phone,
      Email: data[i].email,
      "Địa chỉ": data[i].address,
      "Mặt hàng cung cấp": (data[i].company_provider_item || []).map(
        (item) => item.name
      ).join(", "),
      "Tổng tiền nhập": data[i].total_price_income,
      "Tổng đã trả": data[i].total_price_outcome,
      "Còn lại": data[i].total_price_pending,
      "Thời gian bắt đầu nhập": data[i].createdAt,
      "Thời gian nhập gần nhất": data[i].updatedAt,
    });
  }
  return custs;
};

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

const exportToCSV = ({ csvData, fileName }) => {
  const ws = XLSX.utils.json_to_sheet(csvData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};

const ROLE_ALIAS = "company_provider";
const isMobileProviderViewport = () =>
  typeof window !== "undefined" && window.innerWidth < 992;

class ContentComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: {
        pageSizes: [12, 24],
        selectedPageSize: 12,
        currentPage: 1,
        totalPage: 1,
        totalItem: 0,
        search: "",
      },
      selectedItems: [],
      data: [],
      data_all: [],
      data_stocks: [],

      data_company_provider: null,
      filter: null,

      data_dynamic_form: [],
      is_loading_data: true,
      show: {
        add: false,
        add_item: false,
        add_item_log: false,
        update: false,
        view: false,
        viewonly: true,
      },
      accordion: [],
      activeTab: "1",
      displayMode: "list",
      form: DEFAULT_FORM,
      changedProviders: {},
      modalItems: false,
      selectedProvider: null,
      selectedProviderForDetail: null,
      isDetailOpen: false,
      updateModalInitialTab: "1",
    };

    this.socket = createSocket();
  }

  handleRefreshCompanyProviderList = () => {
    this.dataListRender();
    this.dataAllRender();
    this.dataRenderStocks();

    // Refresh selectedProviderForDetail if it is open
    if (this.state.isDetailOpen && this.state.selectedProviderForDetail) {
      setTimeout(() => {
        const updated = this.state.data_all.find(
          (p) => p.id === this.state.selectedProviderForDetail.id
        );
        if (updated) {
          this.setState({ selectedProviderForDetail: updated });
        }
      }, 500);
    }
  };

  onClickedItemForDetail = (item) => {
    this.setState({
      selectedProviderForDetail: item,
      isDetailOpen: true,
    });
  };

  onCloseDetail = () => {
    this.setState({
      selectedProviderForDetail: null,
      isDetailOpen: false,
    });
  };

  handleDownloadData = () => {
    const fileName = "Danh sách Nhà cung cấp";
    exportToCSV({
      csvData: formatDatasExport(this.state.data_all),
      fileName,
    });
  };


  componentDidMount() {
    this.socket.emit("join room", {
      room_id: localStorage.getItem("user_id"),
    });

    // Set search context cho Navbar
    this.props.setSearchContext("provider");

    this.dataListRender();
    this.dataAllRender();
    this.dataRenderStocks();

    window.addEventListener("refresh-company-provider-list", this.handleRefreshCompanyProviderList);
  }

  componentWillUnmount() {
    window.removeEventListener("refresh-company-provider-list", this.handleRefreshCompanyProviderList);
  }

  componentDidUpdate(prevProps) {
    // Listen thay đổi searchKeyword từ Redux (Navbar search)
    if (prevProps.searchKeyword !== this.props.searchKeyword) {
      this.setState(
        (prev) => ({
          ...prev,
          page: {
            ...prev.page,
            search: this.props.searchKeyword,
          },
        }),
        () => this.dataListRender(),
      );
    }
  }

  /** Axios func helper */
  dataListRender = () => {
    const { selectedPageSize, currentPage, search } = this.state.page;

    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(
        `${
          END_POINT + "/company-provider/json"
        }?pageSize=${selectedPageSize}&currentPage=${currentPage}&search=${search}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((data) => {
        let anyAccordion = [];
        let numeroPerguntas = data.data.length;
        for (var i = 0; i < numeroPerguntas; i++) {
          // if (!i) {
          //     anyAccordion.push(true);
          // }
          anyAccordion.push(false);
        }

        this.setState(
          (prev) => ({
            ...prev,
            data: data.data,
            data_dynamic_form: data.dataDynamicForm,
            is_loading_data: false,
            page: {
              ...prev.page,
              totalPage: data.totalPage,
              totalItem: data.totalItem,
            },
            accordion: anyAccordion,
          }),
          () => {
            // Auto select first provider if none is selected
            if (
              !isMobileProviderViewport() &&
              !this.state.selectedProviderForDetail &&
              data.data &&
              data.data.length > 0
            ) {
              this.setState({
                selectedProviderForDetail: data.data[0],
                isDetailOpen: true,
              });
            }

            if (this.state.selectedProviderForDetail) {
              const updatedDetailProvider = data.data.find(
                (p) => p.id === this.state.selectedProviderForDetail.id,
              );

              if (updatedDetailProvider) {
                this.setState({ selectedProviderForDetail: updatedDetailProvider });
              }
            }

            // Cập nhật lại selectedProvider nếu đang hiển thị Modal để đồng bộ số dư mới nhất
            if (this.state.modalItems && this.state.selectedProvider) {
              const updatedProvider = data.data.find(
                (p) => p.id === this.state.selectedProvider.id,
              );

              if (updatedProvider) {
                this.setState({ selectedProvider: updatedProvider });
              }
            }

            if (this.state.form.id) {
              const {
                id,
                name,
                phone,
                email,
                address,
                total_price_income,
                total_price_outcome,
                total_price_pending,
                company_provider_item,
                dynamic_form,
              } = this.state.form;
              this.setState((prev) => ({
                ...prev,
                form: {
                  ...prev.form,
                  id,
                  name,
                  phone,
                  email,
                  address,
                  total_price_income,
                  total_price_outcome,
                  total_price_pending,
                  log: company_provider_item,
                  dynamic_form,
                },
              }));
            } else {
              this.setState((prev) => ({
                ...prev,
                selectedItems: [],
                show: {
                  ...prev.show,
                  update: false,
                },
                form: DEFAULT_FORM,
              }));
            }
          },
        );
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  dataAllRender = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/company-provider"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        this.setState((prev) => ({
          ...prev,
          data_all: data.data,
          selectedProviderForDetail: prev.selectedProviderForDetail
            ? data.data.find((p) => p.id === prev.selectedProviderForDetail.id) ||
              prev.selectedProviderForDetail
            : prev.selectedProviderForDetail,
        }));
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  dataRenderStocks = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/stock/all-unit"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        this.setState((prev) => ({
          ...prev,
          data_stocks: data.data,
        }));
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  onHandlerDelete = () => {
    if (!isD(ROLE_ALIAS)) return false;

    let tokenStr = localStorage.getItem("access_token");
    console.log(this.state.selectedItems);
    console.log(tokenStr);
    axios
      .delete(`${END_POINT + "/company-provider"}`, {
        data: {
          arrayId: this.state.selectedItems,
        },
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["company-provider-delete"],
        });

        this.dataListRender();
        this.dataAllRender();
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  onHandlerUpdate = (e) => {
    if (!isU(ROLE_ALIAS)) return false;
    e.preventDefault();

    const { id, name, phone, items_selected, email, address, tax_code, notes, dynamic_form } =
      this.state.form;

    if (!name || !id) {
      NotificatioErrController("Dữ liệu không hợp lệ");
      return;
    }

    let tokenStr = localStorage.getItem("access_token");
    axios
      .put(
        `${END_POINT + "/company-provider"}`,
        {
          id,
          name,
          phone,
          email,
          items_to_create: items_selected,
          address,
          tax_code,
          notes,
          dynamic_form,
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        },
      )
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Cập nhật nhà cung cấp thành công!");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["company-provider-update"],
        });

        this.dataListRender();
        this.dataAllRender();
        this.toggle("update");
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  onHandlerAdd = () => {
    if (!isC(ROLE_ALIAS)) return false;

    // `items_selected` bây giờ là một MẢNG hoặc null
    const { name, phone, email, address, tax_code, notes, dynamic_form, items_selected } =
      this.state.form;

    if (!name) {
      NotificatioErrController("Tên nhà cung cấp cần được thêm vào");
      return;
    }

    // Tạo payload để gửi đi
    const payload = {
      name,
      phone,
      email,
      address,
      tax_code,
      notes,
      dynamic_form,
      items_to_create: items_selected || [], // Gửi mảng rỗng nếu không có item nào được chọn
    };

    let tokenStr = localStorage.getItem("access_token");
    axios
      .post(`${END_POINT + "/company-provider"}`, payload, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["company-provider-create"],
        });

        this.dataListRender();
        this.dataAllRender();
        // this.toggle('add');
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  onHandlerAddItem = () => {
    if (!isC(ROLE_ALIAS)) return false;
    const isUpdateModalOpen = this.state.show.update;
    const isLegacyAddItemModalOpen = this.state.show.add_item;

    // items_selected bây giờ là một OBJECT hoặc NULL
    const {
      id,
      items_selected,
      price_income,
      price_outcome,
      price,
      quantity,
      new_item_unit,
    } = this.state.form;

    // Kiểm tra items_selected là một object hợp lệ
    if (!id || !items_selected || !price || !quantity) {
      NotificatioErrController(
        "Dữ liệu không hợp lệ, vui lòng điền đủ các trường bắt buộc",
      );
      return;
    }

    // THÊM VALIDATION cho đơn vị tính nếu là item mới
    if (items_selected?.__isNew__ && !new_item_unit) {
      NotificatioErrController("Vui lòng nhập đơn vị tính cho mặt hàng mới");
      return;
    }

    // Tạo payload để gửi đi
    const payload = {
      id,
      item_data: { ...items_selected }, // Copy object để có thể thay đổi
      price: price.toString().replace(/\./g, ""),
      quantity,
      price_income: price_income.toString().replace(/\./g, ""),
      price_outcome: (price_outcome || "0").toString().replace(/\./g, ""),
    };

    // THÊM đơn vị tính vào payload nếu là item mới
    if (payload.item_data.__isNew__) {
      payload.item_data.unit = new_item_unit;
    }

    let tokenStr = localStorage.getItem("access_token");
    axios
      .post(`${END_POINT + "/company-provider/item"}`, payload, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["company-provider-create-log"],
        });

        this.dataListRender();
        this.dataAllRender();
        this.setState((prev) => ({
          ...prev,
          show: {
            ...prev.show,
            update: isUpdateModalOpen ? false : prev.show.update,
            add_item: isLegacyAddItemModalOpen ? false : prev.show.add_item,
          },
          updateModalInitialTab: "1",
          form: DEFAULT_FORM,
        }));
      })
      .catch((err) => {
        const message =
          err.response?.data?.responseText ||
          "Có lỗi xảy ra, vui lòng thử lại.";
        NotificatioErrController(message);
      });
  };

  onHandlerAddLog = () => {
    if (!isC(ROLE_ALIAS)) return false;

    const { item_id, price_outcome } = this.state.form;

    if (
      !item_id ||
      price_outcome === "" ||
      price_outcome === null ||
      price_outcome === undefined
    ) {
      NotificatioErrController("Dữ liệu không hợp lệ");
      return;
    }

    let tokenStr = localStorage.getItem("access_token");
    axios
      .post(
        `${END_POINT + "/company-provider/log"}`,
        {
          id: item_id,
          price_outcome: price_outcome.toString().replace(/\./g, ""),
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        },
      )
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["company-provider-create-log"],
        });

        this.toggleItem("add_item_log");
        this.dataListRender();
        this.dataAllRender();
        this.setState({
          form: DEFAULT_FORM,
        });
      })
      .catch((err) => {
        const message =
          err.response?.data?.responseText ||
          "Có lỗi xảy ra, vui lòng thử lại.";
        NotificatioErrController(message);
      });
  };
  /** Axios func helper */

  /** State func helper */
  toggle = (name) => {
    if (name === "add" && !isC(ROLE_ALIAS)) return false;
    if (name === "update" && !isU(ROLE_ALIAS)) return false;

    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        update: name === "add" ? false : prev.show.update,
        [name]: !prev.show[name],
      },
      selectedItems: name === "add" ? [] : prev.selectedItems,
      form: name === "add" ? DEFAULT_FORM : prev.form,
    }));
  };

  hideDisplayContent = () => {
    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        view: false,
      },
    }));
  };

  toggleItem = (name, item) => {
    if (name === "add_item" && !isU(ROLE_ALIAS)) return false;
    if (name === "add_item_log" && !isU(ROLE_ALIAS)) return false;

    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        [name]: !prev.show[name],
      },
      form: {
        ...prev.form,
        id: item?.id,
      },
      selectedItems: [item?.id],
    }));
  };
  toggleItemLog = (item) => {
    if (!isU(ROLE_ALIAS)) return false;

    const { id, name, price_income, price_outcome } = item;
    const price_pending = (price_income || 0) - (price_outcome || 0);

    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        add_item_log: true,
      },
      form: {
        ...prev.form,
        item_id: id,
        item_name: name,
        price_outcome: "",
        price_pending: price_pending,
      },
    }));
  };

  // onChangeForm = (e, _name) => {
  //     if (e.target) {
  //         let {
  //             target: { name, value },
  //         } = e;
  //         this.setState((prev) => ({
  //             ...prev,
  //             form: {
  //                 ...prev.form,
  //                 [name]: value,
  //             },
  //         }));
  //     } else {
  //         this.setState((prev) => ({
  //             ...prev,
  //             form: {
  //                 ...prev.form,
  //                 [_name]: e,
  //                 // Nếu người dùng chọn một item cũ, reset unit
  //                 new_item_unit: e?.__isNew__ ? prev.form.new_item_unit : ''
  //             },
  //         }));
  //     }
  // };

  onChangeForm = (eventOrValue, nameOrIndex) => {
    // --- TRƯỜNG HỢP 1: XỬ LÝ COMPONENT REACT-SELECT (Creatable) ---
    // Nhận diện bằng cách `nameOrIndex` là một chuỗi (ví dụ 'items_selected')
    if (typeof nameOrIndex === "string") {
      const _name = nameOrIndex;
      const _value = eventOrValue;

      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          [_name]: _value,
        },
      }));
      return; // Kết thúc sớm
    }

    // Từ đây trở đi, chúng ta xử lý các event từ input HTML (có target)
    const {
      target: { name, value },
    } = eventOrValue;

    // --- TRƯỜDNG HỢP 2: XỬ LÝ INPUT PRICE/QUANTITY CỦA MỘT ITEM TRONG MẢNG ---
    // Nhận diện bằng cách `nameOrIndex` là một số (index của item)
    if (typeof nameOrIndex === "number") {
      const itemIndex = nameOrIndex;

      this.setState((prev) => {
        // 1. Tạo một bản sao của mảng items_selected để không thay đổi state trực tiếp (immutability)
        const updatedItems = [...prev.form.items_selected];

        // 2. Tạo một bản sao của đối tượng item cần cập nhật
        const itemToUpdate = { ...updatedItems[itemIndex] };

        // 3. Cập nhật thuộc tính ('price' hoặc 'quantity') cho item đó
        // `name` được lấy từ e.target.name ('price' hoặc 'quantity')
        itemToUpdate[name] = name === "price"
          ? parseFloat(value.toString().replace(/\./g, "")) || 0
          : value;

        // 4. Thay thế item cũ bằng item đã cập nhật trong mảng bản sao
        updatedItems[itemIndex] = itemToUpdate;

        // 5. Cập nhật state với mảng mới
        return {
          ...prev,
          form: {
            ...prev.form,
            items_selected: updatedItems,
          },
        };
      });
      return; // Kết thúc sớm
    }

    const price_income =
      Number(
        this.state.form.price.toString().replace(/\./g, "") *
          Number(this.state.form.quantity),
      ) || 0;

    // --- TRƯỜNG HỢP 3: XỬ LÝ CÁC INPUT THÔNG THƯỜNG KHÁC (name, phone, address...) ---
    // Nhận diện khi chỉ có tham số `event` được truyền vào (nameOrIndex là undefined)
    const isPriceField = ["price", "price_outcome", "price_income", "price_pending"].includes(name);
    const parsedValue = isPriceField
      ? parseFloat(value.toString().replace(/\./g, "")) || 0
      : value;

    this.setState((prev) => ({
      ...prev,
      form: {
        ...prev.form,
        [name]: parsedValue,
        price_income,
      },
    }));
  };
  onChangeFormPrice = (e, _name) => {
    if (e.target) {
      let {
        target: { name, value },
      } = e;

      let input_value = parseFloat(value.toString().replace(/\./g, "")) || 0;
      let price_outcome =
        parseFloat(
          this.state.form.price_outcome.toString().replace(/\./g, ""),
        ) || 0;
      let price_income =
        parseFloat(
          this.state.form.price.toString().replace(/\./g, "") *
            Number(this.state.form.quantity),
        ) || 0;
      // Number(
      //     this.state.form.price.replace(/\./g, '')
      // ) * Number(
      //     this.state.form.quantity.replace(/\./g, '')
      // ) || 0;

      let price_pending = 0;
      if (name === "price_income") {
        price_pending = input_value - price_outcome;
      }
      if (name === "price_outcome") {
        price_pending = price_income - input_value;
      }

      let price_parse = parseFloat(price_pending);

      if (isNaN(price_parse)) {
        price_pending = 0;
      } else if (price_parse < 0) {
        price_pending = 0;
      }

      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          [name]: input_value,
          // price_income,
          price_pending,
        },
      }));
    }
  };

  onChangeDynamicForm = (e, _name) => {
    if (e.target) {
      let {
        target: { name, value },
      } = e;

      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          dynamic_form: {
            ...prev.form.dynamic_form,
            [name]: value,
          },
        },
      }));
    } else {
      let value = e.value ? e.value : e;

      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          dynamic_form: {
            ...prev.form.dynamic_form,
            [_name]: value,
          },
        },
      }));
    }
  };

  onSubmitForm = (type, e) => {
    e.preventDefault();
    if (type === "update") {
      this.onHandlerUpdate();
    } else if (type === "add") {
      this.onHandlerAdd();
    } else if (type === "add-item") {
      this.onHandlerAddItem();
    } else if (type === "add-item-log") {
      this.onHandlerAddLog();
    }
  };

  handleDataUpdate = (changedItems) => {
    this.setState((prevState) => {
      const newChanged = { ...prevState.changedProviders };
      const updatedAllData = [...prevState.data_all];
      const updatedData = [...prevState.data];

      changedItems.forEach((changedItem) => {
        if (changedItem.id) {
          newChanged[changedItem.id] = changedItem;
        }
        // Sync data_all
        const idxAll = updatedAllData.findIndex((c) => c.id === changedItem.id);
        if (idxAll !== -1) {
          updatedAllData[idxAll] = changedItem;
        }
        // Sync data
        const idxPage = updatedData.findIndex((c) => c.id === changedItem.id);
        if (idxPage !== -1) {
          updatedData[idxPage] = changedItem;
        }
      });

      return {
        changedProviders: newChanged,
        data_all: updatedAllData,
        data: updatedData,
      };
    });
  };

  handleSaveChanges = async () => {
    const { changedProviders } = this.state;
    const dataToSend = Object.values(changedProviders);

    if (dataToSend.length === 0) return;

    try {
      const tokenStr = localStorage.getItem("access_token");
      const response = await axios.put(
        `${END_POINT}/company-provider/bulk-update`,
        dataToSend,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      );

      NotificatioSucController(
        response.data.responseText || "Cập nhật thành công!",
      );

      this.socket.emit("create logs", {
        user_id: localStorage.getItem("user_id"),
        message: LogsHelper["company-provider-update"],
      });

      this.setState({ changedProviders: {} });
      this.dataAllRender();
      this.dataListRender();
    } catch (err) {
      NotificatioErrController(
        err.response?.data?.responseText || "Có lỗi xảy ra, vui lòng thử lại.",
      );
    }
  };

  toggleModalItems = (provider = null) => {
    this.setState((prev) => ({
      modalItems: !prev.modalItems,
      selectedProvider: provider,
    }));
  };

  onChangePage = (page) => {
    this.setState(
      (prev) => ({
        ...prev,
        page: {
          ...prev.page,
          currentPage: page,
        },
      }),
      () => this.dataListRender(),
    );
  };

  onSearchKey = (e) => {
    if (!e) return false;

    if (e.target) {
      let {
        target: { value },
      } = e;
      let v = value;
      if (value === undefined) {
        v = e.target.firstElementChild.value; // parent to child

        // value = v.toLowerCase();
        // this.setState(
        //     (prev) => ({
        //         ...prev,
        //         page: {
        //             ...prev.page,
        //             search: value,
        //         },
        //     }),
        //     () => this.dataListRender()
        // );
      }
      // else {
      //     value = value.toLowerCase();
      //     this.setState(
      //         (prev) => ({
      //             ...prev,
      //             page: {
      //                 ...prev.page,
      //                 search: value,
      //             },
      //         }),
      //         () => this.dataListRender()
      //     );
      // }
    }

    if (e.key === "Enter") {
      let value = e.target.value.toLowerCase();
      this.setState(
        (prev) => ({
          ...prev,
          page: {
            ...prev.page,
            search: value,
          },
        }),
        () => this.dataListRender(),
      );
    }
  };

  onChangePageSize = (size) => {
    this.setState(
      (prev) => ({
        ...prev,
        page: {
          ...prev.page,
          selectedPageSize: size,
          currentPage: 1,
        },
      }),
      () => this.dataListRender(),
    );
  };

  onClickedItem = (item, callback, args) => {
    const {
      id,
      name,
      phone,
      email,
      address,
      tax_code,
      notes,
      total_price_income,
      total_price_outcome,
      total_price_pending,
      company_provider_item,
      dynamic_form,
    } = item;

    this.setState(
      (prev) => ({
        ...prev,
        show: {
          ...prev.show,
          update: false,
          view: false, // Tắt chế độ xem chia màn hình
          viewonly: false,
        },
        form: {
          ...prev.form,
          id,
          name,
          phone,
          email,
          address,
          tax_code: tax_code || "",
          notes: notes || "",
          total_price_income,
          total_price_outcome,
          total_price_pending,
          dynamic_form,
          log: company_provider_item,
        },
        selectedItems: [item.id],
      }),
      () => {
        if (callback && typeof callback === "function") {
          callback(args[0], args[1], args[2]);
        }
      },
    );
  };

  onClickedUpdate = (item, initialTab = "1") => {
    const {
      id,
      name,
      phone,
      email,
      address,
      tax_code,
      notes,
      total_price_income,
      total_price_outcome,
      total_price_pending,
      company_provider_item,
      dynamic_form,
    } = item;

    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        viewonly: false,
        update: true,
      },
      updateModalInitialTab: initialTab,
      form: {
        ...prev.form,
        id,
        name,
        phone,
        email,
        address,
        tax_code: tax_code || "",
        notes: notes || "",
        total_price_income,
        total_price_outcome,
        total_price_pending,
        dynamic_form,
        log: company_provider_item,
        price: "",
        quantity: "",
        price_income: "",
        price_outcome: "",
        price_pending: "",
        new_item_unit: "",
        items_selected:
          initialTab === "2"
            ? null
            : company_provider_item?.map((item) => ({
                label: item.name,
                value: item.name,
                // price: item.stock.price_new,
                // quantity: item.stock.count,
              })),
      },
      selectedItems: [item.id],
    }));
  };

  onAddTransactionFromDetail = (item) => {
    this.onClickedUpdate(item, "2");
  };

  onClickedDelete = (item) => {
    let selectedSet = SetItemsSelected(
      item.id,
      this.state.selectedItems,
      "require",
    );
    if (window.confirm("Bạn chắc chắn muốn xoá nhà cung cấp này?")) {
      this.setState(
        (prev) => ({
          ...prev,
          selectedItems: selectedSet,
        }),
        () => this.onHandlerDelete(),
      );
    }
  };

  onClickedCheckbox = (id, callback) => {
    let selectedSet = SetItemsSelected(id, this.state.selectedItems);

    this.setState((prev) => ({
      ...prev,
      selectedItems: selectedSet,
    }));
  };

  onHandlerDelete = () => {
    if (!isD(ROLE_ALIAS)) return false;

    let tokenStr = localStorage.getItem("access_token");
    const { selectedItems } = this.state;
    if (selectedItems.length === 0) return;

    axios
      .delete(`${END_POINT}/company-provider`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
        data: { arrayId: selectedItems },
      })
      .then((res) => {
        NotificatioSucController("Xóa nhà cung cấp thành công");
        this.dataListRender();
        this.dataAllRender();
        this.setState({ selectedItems: [] });

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["company-provider-delete"],
        });
      })
      .catch((err) => {
        NotificatioErrController(
          err.response?.data?.responseText || "Có lỗi xảy ra",
        );
      });
  };

  handleChangeSelectAll = (isToggle) => {
    const { selectedItems, data, data_all, displayMode } = this.state;
    const targetData = displayMode === "list" ? data_all : data;

    if (selectedItems.length >= targetData.length) {
      if (isToggle) {
        this.setState({ selectedItems: [] });
      }
    } else {
      this.setState({ selectedItems: targetData.map((x) => x.id) });
    }
    document.activeElement.blur();
    return false;
  };
  /** State func helper */

  toggleAccordion = (tab) => {
    const prevState = this.state.accordion;
    const state = prevState.map((x, index) => (tab === index ? !x : false));
    this.setState({
      accordion: state,
    });
  };

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  filterData = (key, value) => {
    const { data_all } = this.state;

    // Helper to calculate totals client-side
    const getTotals = (item) => {
      const items = item.company_provider_item || [];
      const income = items.reduce((acc, curr) => acc + (parseFloat(curr.price_income) || 0), 0);
      const outcome = items.reduce((acc, curr) => acc + (parseFloat(curr.price_outcome) || 0), 0);
      const pending = items.reduce((acc, curr) => acc + (parseFloat(curr.price_pending) || 0), 0);
      return { income, outcome, pending };
    };

    if (key === "" && value === "") {
      this.setState((prev) => ({
        ...prev,
        data: data_all,
        filter: null,
      }));
    } else if (key === "outcome-lessthan-income" || (key === "status" && value === "debt")) {
      const filteredStatus = data_all.filter((item) => {
        const { income, outcome } = getTotals(item);
        return income > outcome;
      });
      this.setState((prev) => ({
        ...prev,
        data: filteredStatus,
        filter: { column: key, value },
      }));
    } else if (key === "outcome-equal-income" || (key === "status" && value === "paid")) {
      const filteredStatus = data_all.filter((item) => {
        const { income, outcome } = getTotals(item);
        return income === outcome && income > 0;
      });
      this.setState((prev) => ({
        ...prev,
        data: filteredStatus,
        filter: { column: key, value },
      }));
    } else if (key === "total_price_income" && value === "0") {
      const filteredStatus = data_all.filter((item) => {
        const { income } = getTotals(item);
        return income === 0;
      });
      this.setState((prev) => ({
        ...prev,
        data: filteredStatus,
        filter: { column: key, value },
      }));
    } else if (key === "item_product") {
      const filteredItemProduct = data_all.filter((item) =>
        (item.company_provider_item || []).find((i) => i.name === value),
      );
      this.setState((prev) => ({
        ...prev,
        data: filteredItemProduct,
        filter: { column: key, value },
      }));
    } else {
      const filteredItems = data_all.filter((item) => item[key] === value);
      this.setState((prev) => ({
        ...prev,
        data: filteredItems,
        filter: { column: key, value },
      }));
    }
  };


  changeDisplayMode = (mode) => {
    this.setState((prev) => ({
      ...prev,
      displayMode: mode,
      show: {
        ...prev.show,
        view: false,
      },
    }));
    return false;
  };

  render() {
    const { match } = this.props;
    const {
      page,
      selectedItems,
      data,
      data_all,
      data_stocks,
      filter,
      data_tags,
      is_loading_data,
      show,
      form,
      accordion,
      displayMode,
      data_dynamic_form,
    } = this.state;
    const isMobileDetailModal = isMobileProviderViewport();
    const detailProvider =
      this.state.selectedProviderForDetail ||
      (!isMobileDetailModal && data && data.length > 0 ? data[0] : null);
    const isDesktopDetailVisible = !isMobileDetailModal && Boolean(detailProvider);
    const isDetailVisible = isMobileDetailModal
      ? this.state.isDetailOpen
      : isDesktopDetailVisible;

    if (!isR(ROLE_ALIAS))
      return (
        <Card className="text-muted mh-40vh h-100">
          <CardBody className="d-flex justify-content-center align-items-center">
            Bạn không có quyền sử dụng tính năng này!
          </CardBody>
        </Card>
      );

    return is_loading_data ? (
      <div className="loading" />
    ) : (
      <div
        className={classnames("disable-text-selection provider-page-layout", {
          "detail-open": isDetailVisible,
        })}
      >
        <div className={classnames("provider-main-layout", { "with-detail": isDetailVisible })}>
          <div className="provider-content-area">
        {/* Breadcrumb row */}
        {/* <div className="d-flex justify-content-between align-items-center mb-3 provider-page-heading">
          <div>
            <h1 className="mb-0 d-inline-block" style={{ fontSize: "24px", fontWeight: "700" }}>Nhà cung cấp</h1>
            <span className="text-muted ml-3" style={{ fontSize: "12px" }}>Quản lý » Nhà cung cấp</span>
          </div>
        </div> */}

        {/* KPI Summary Row */}
        <ProviderKPISummary dataAll={data_all} />

        {/* Search & Filter Bar */}
        <ProviderFilterBar
          dataAll={data_all}
          activeFilter={filter}
          filterData={this.filterData}
          onSearchKeyFunc={this.onSearchKey}
          handleDownloadData={this.handleDownloadData}
          displayMode={displayMode}
          changeDisplayMode={this.changeDisplayMode}
          showAddBtn={isC(ROLE_ALIAS)}
          onAddClick={() => {
            this.toggle("add");
            this.hideDisplayContent();
            this.toggleAccordion();
          }}
        />


        <AddCompanyProvider
          title={<IntlMessages id="company-provider.add-new-modal-title" />}
          isOpen={show.add}
          toggle={() => {
            this.toggle("add");
          }}
          data_dynamic_form={data_dynamic_form}
          values={form}
          data_stocks={data_stocks}
          setting={show}
          onChange={this.onChangeForm}
          onChangeDynamicForm={this.onChangeDynamicForm}
          onSubmit={(e) => {
            this.onSubmitForm("add", e);
          }}
        />
        <AddCompanyProviderLog
          title={<IntlMessages id="company-provider.title-log" />}
          isOpen={show.add_item}
          toggle={() => {
            this.toggleItem("add_item");
          }}
          values={form}
          data_stocks={data_stocks}
          setting={show}
          onChange={this.onChangeForm}
          onChangePrice={this.onChangeFormPrice}
          onSubmit={(e) => {
            this.onSubmitForm("add-item", e);
          }}
        />
        <AddCompanyProviderItemLog
          title={<IntlMessages id="company-provider.title-log-add-more" />}
          isOpen={show.add_item_log}
          toggle={() => {
            this.toggleItem("add_item_log");
          }}
          values={form}
          setting={show}
          onChange={this.onChangeForm}
          onSubmit={(e) => {
            this.onSubmitForm("add-item-log", e);
          }}
        />
        <UpdateCompanyProvider
          title={<IntlMessages id="company-provider.title" />}
          onSubmit={this.onHandlerUpdate}
          onSubmitTransaction={(e) => {
            this.onSubmitForm("add-item", e);
          }}
          isOpen={show.update}
          initialActiveTab={this.state.updateModalInitialTab}
          toggle={() => {
            this.toggle("update");
          }}
          data_dynamic_form={data_dynamic_form}
          data_tags={data_tags}
          values={form}
          data_stocks={data_stocks}
          setting={show}
          onChange={this.onChangeForm}
          onChangePrice={this.onChangeFormPrice}
          onChangeDynamicForm={this.onChangeDynamicForm}
        />

        {/* Modal chi tiết mặt hàng - Di chuyển lên đây để tránh lỗi bóng mờ UI */}
        <Modal
          isOpen={this.state.modalItems}
          toggle={() => this.toggleModalItems()}
          size="xl"
          fade={false}
          zIndex={2000}
          className="modal-items-detail"
        >
          <ModalHeader toggle={() => this.toggleModalItems()}>
            Danh sách mặt hàng cung cấp -{" "}
            {this.state.selectedProvider?.name || ""}
          </ModalHeader>
          <ModalBody>
            <Table striped responsive hover className="mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Tên mặt hàng</th>
                  <th>Mã SKU</th>
                  <th className="text-center">Số lượng</th>
                  <th className="text-right">Đơn giá</th>
                  <th className="text-right">Thành tiền</th>
                  <th className="text-right">Còn nợ</th>
                  <th className="text-center">Ngày nhập</th>
                  <th className="text-center">Thao tác</th>
                </tr>
              </thead>
              <tbody>
                {this.state.selectedProvider?.company_provider_item?.length >
                0 ? (
                  this.state.selectedProvider.company_provider_item.map(
                    (item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td className="font-weight-bold">{item.name}</td>
                        <td>{item.stock?.sku || "-"}</td>
                        <td className="text-center">{item.quantity || 0}</td>
                        <td className="text-right">
                          {AddCommaNumber(item.stock?.price_new || 0)}
                        </td>
                        <td className="text-right">
                          {AddCommaNumber(item.price_income || 0)}
                        </td>
                        <td className="text-right font-weight-bold text-danger">
                          {AddCommaNumber(
                            (item.price_income || 0) -
                              (item.price_outcome || 0),
                          )}
                        </td>
                        <td className="text-center">
                          {item.createdAt
                            ? moment(item.createdAt).format("DD/MM/YYYY")
                            : "-"}
                        </td>
                        <td className="text-center">
                          {(item.price_income || 0) -
                            (item.price_outcome || 0) >
                            0 && (
                            <Button
                              color="success"
                              outline
                              size="xs"
                              onClick={() => {
                                this.toggleModalItems();
                                this.toggleItemLog(item);
                                this.hideDisplayContent();
                              }}
                            >
                              Thanh toán
                            </Button>
                          )}
                        </td>
                      </tr>
                    ),
                  )
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center text-muted p-4">
                      Không có mặt hàng nào.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </ModalBody>
        </Modal>
        {data.length === 0 ? (
          <Card className="mt-4 mb-4 mh-53vh">
            <CardBody>Chưa có dữ liệu...</CardBody>
          </Card>
        ) : (
          <React.Fragment>
              {displayMode === "list" ? (
                <ProviderDataTable
                  data={data}
                  selectedItems={selectedItems}
                  onChangeCheckbox={this.onClickedCheckbox}
                  onSelectAll={this.handleChangeSelectAll}
                  onClickedItem={this.onClickedItemForDetail}
                  onClickedUpdate={this.onClickedUpdate}
                  onClickedDelete={this.onClickedDelete}
                  toggleItemLogFunc={this.toggleItemLog}
                  selectedProviderId={this.state.selectedProviderForDetail?.id}
                />
              ) : (
                <Row className="content-page__row d-none d-md-flex">
                  <Col xs="12" sm="12" md="12" lg={12} xl={12}>
                    {data?.map((item, idx) => (
                      <ListItemLeftForm
                        onClickedItem={this.onClickedItemForDetail}
                        onUpdate={this.onClickedUpdate}
                        onDelete={this.onClickedDelete}
                        onChangeCheckbox={this.onClickedCheckbox}
                        isDisabledUpdate={!isU(ROLE_ALIAS)}
                        isDisabledDelete={!isD(ROLE_ALIAS)}
                        selectedItems={selectedItems}
                        key={idx}
                        idx={idx}
                        item={item}
                        toggleFunc={(item) => {
                          this.toggleItem("add_item", item);
                        }}
                        toggleItemLogFunc={this.toggleItemLog}
                      />
                    ))}
                  </Col>
                </Row>
              )}

              {/* Mobile rendering fallback */}
              <Row className="content-page__row d-block d-md-none mb-4">
                <Col>
                  {data?.map((item, idx) => (
                    <div className="d-flex mb-3 card" key={item.id}>
                      <ListItemFormMobile
                        onClickedItem={this.onClickedItemForDetail}
                        toggleFunc={() => {
                          this.toggleItem("add_item");
                        }}
                        onUpdate={this.onClickedUpdate}
                        onDelete={this.onClickedDelete}
                        onChangeCheckbox={this.onClickedCheckbox}
                        isDisabledUpdate={!isU(ROLE_ALIAS)}
                        isDisabledDelete={!isD(ROLE_ALIAS)}
                        selectedItems={selectedItems}
                        key={idx}
                        idx={idx}
                        item={item}
                        form={form}
                        accordion={accordion}
                        toggleAccordion={this.toggleAccordion}
                        data_tags={data_tags}
                      />
                    </div>
                  ))}
                </Col>
              </Row>

              <Row className="d-flex justify-content-center mt-3">
                <Pagination
                  currentPage={page.currentPage}
                  totalPage={page.totalPage}
                  onChangePage={(i) => this.onChangePage(i)}
                />
              </Row>
          </React.Fragment>
        )}
          </div>

          {!isMobileDetailModal && (
            <ProviderDetailPanel
              provider={detailProvider}
              isOpen={isDesktopDetailVisible}
              onClose={() => {}}
              onAddTransaction={this.onAddTransactionFromDetail}
              canAddTransaction={isC(ROLE_ALIAS)}
              onRefresh={() => {
                this.dataListRender();
                this.dataAllRender();
                if (this.state.selectedProviderForDetail?.id) {
                  this.onClickedItemForDetail(this.state.selectedProviderForDetail);
                }
              }}
              toggleItemLogFunc={(item) => {
                this.toggleItemLog(item);
              }}
            />
          )}
        </div>

        {isMobileDetailModal && (
          <Modal
            isOpen={this.state.isDetailOpen}
            toggle={this.onCloseDetail}
            wrapClassName="modal-right provider-detail-mobile-modal"
            backdrop={true}
            fade={false}
          >
            <ModalHeader toggle={this.onCloseDetail}>
              Chi tiết nhà cung cấp
            </ModalHeader>
            <ModalBody className="scrool modal-right-add provider-detail-modal-body">
              <ProviderDetailPanel
                provider={detailProvider}
                isOpen={this.state.isDetailOpen}
                onClose={this.onCloseDetail}
                onAddTransaction={this.onAddTransactionFromDetail}
                canAddTransaction={isC(ROLE_ALIAS)}
                isModalMode={true}
                showCloseButton={false}
                onRefresh={() => {
                  this.dataListRender();
                  this.dataAllRender();
                  if (this.state.selectedProviderForDetail?.id) {
                    this.onClickedItemForDetail(this.state.selectedProviderForDetail);
                  }
                }}
                toggleItemLogFunc={(item) => {
                  this.onCloseDetail();
                  this.toggleItemLog(item);
                }}
              />
            </ModalBody>
          </Modal>
        )}

        <Separator />
        <FooterPage>
          <FooterCompanyProvider />
        </FooterPage>

        {/* Modal chi tiết mặt hàng */}
      </div>
    );
  }
}

const mapStateToProps = ({ searchInput }) => {
  const { keyword: searchKeyword } = searchInput;
  return { searchKeyword };
};

export default connect(mapStateToProps, {
  setSearchContext,
})(ContentComponent);
